/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessResponseViewModel } from './AccessResponseViewModel';
import {
    AccessResponseViewModelFromJSON,
    AccessResponseViewModelFromJSONTyped,
    AccessResponseViewModelToJSON,
} from './AccessResponseViewModel';

/**
 * 
 * @export
 * @interface ResultOfAccessResponseViewModelAllOf
 */
export interface ResultOfAccessResponseViewModelAllOf {
    /**
     * 
     * @type {AccessResponseViewModel}
     * @memberof ResultOfAccessResponseViewModelAllOf
     */
    data?: AccessResponseViewModel;
    /**
     * 
     * @type {number}
     * @memberof ResultOfAccessResponseViewModelAllOf
     */
    count: number;
}

/**
 * Check if a given object implements the ResultOfAccessResponseViewModelAllOf interface.
 */
export function instanceOfResultOfAccessResponseViewModelAllOf(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "count" in value;

    return isInstance;
}

export function ResultOfAccessResponseViewModelAllOfFromJSON(json: any): ResultOfAccessResponseViewModelAllOf {
    return ResultOfAccessResponseViewModelAllOfFromJSONTyped(json, false);
}

export function ResultOfAccessResponseViewModelAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfAccessResponseViewModelAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'Data') ? undefined : AccessResponseViewModelFromJSON(json['Data']),
        'count': json['Count'],
    };
}

export function ResultOfAccessResponseViewModelAllOfToJSON(value?: ResultOfAccessResponseViewModelAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'Data': AccessResponseViewModelToJSON(value.data),
        'Count': value.count,
    };
}

